import { Tag } from 'antd';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';

const CustomTag = (props: CustomTagProps) => {
  const { label, value, closable, onClose } = props;

  return (
    <Tag
      closable={closable}
      onClose={onClose}
      style={{
        marginRight: '4px',
        color: '#2D3F86',
        border: '1px solid #2D3F86',
        background: 'white',
        borderRadius: '16px',
      }}>
      {label}
    </Tag>
  );
};

export default CustomTag;
